import DataTable from 'datatables.net-react';
import { useEffect, useState } from 'react';
import { Button, Card, Col, Form, Modal, Row } from 'react-bootstrap';
import { useNavigate } from 'react-router-dom';
import Swal from 'sweetalert2';
import { RateOfPointService } from '../../services/RateOfPointService';
import * as BullCache from "../../util/BullCache";
import MarketDropdown from '../components/MarketDropdown';
import ScriptDropdown from '../components/ScriptDropdown';
import { ValanService } from '../../services/ValanService';
import Badge from 'react-bootstrap/Badge';

function Valan() {

    var allScripts = BullCache.getFromCache('allScripts');
    var user = BullCache.getFromCache("user");

    const navigate = useNavigate();

    const [loading, setLoading] = useState(false); 
    const [file, setFile] = useState(null);  
    const [valanList, setValanList] = useState([]);
    const [showModal, setShowModal] = useState(false);
    const [selectedItem, setSelectedItem] = useState([]);

    const fetchValans = () => {
      setLoading(true);
        ValanService.getAll({ 'adminId': user.adminId }).then(res => {
        setLoading(false);
            if (res.code === 1) {
                //const allLists = Object.values(res.data.valan).flat();
                setValanList(res.data.valan);
                
            }
        });
    };

    useEffect(() => {
        fetchValans();  
    }, []);  


    const handleClose = () => {
        setShowModal(false);
    };

    const handleAdd = () => {
        navigate('/addvalan'); 
      };
    

    useEffect(() => {
        const handleEditClick = (event) => {
           
            const rowId = event.target.getAttribute("data-id");
            setShowModal(true);  
        };

        document.addEventListener("click", (event) => {
            if (event.target.classList.contains("icon-pencil")) {
                handleEditClick(event);
            }
        });

        return () => {
            document.removeEventListener("click", handleEditClick);
        };
    }, [valanList]);  

   
    const columns = [
        {
            title: "#",
            render: (data, type, row, full) => full.row + 1,
            className: "font-bold fss-1 ",
            width: "60px",
        },
        {
            title: "START DATE",
            selector: row => row.startDate,
            data: "startDate",
            sortable: false,
            className: "font-bold fss-1 ",
            sortFunction: (a, b) => new Date(b.startDate) - new Date(a.startDate), // Descending order
        },
        {
            title: "END DATE",
            data: "endDate",
            className: "font-bold fss-1 ",
        },
        {
            title: "STATUS",
            data: "status",
            className: "font-bold fss-1 ",
            render: (data, type, row, full, meta) => {
              return `
              <Span class="badge bg-${row.status ? 'success' : 'secondary'}">${row.status ? "ACTIVE" : "INACTIVE"}</Span>
            `;
            }
        },
        {
            title: "LAST UPDATED",
            data: "auditTimestamp",
            className: "font-bold fss-1 ",
        },
        {
            title: "EDIT",
            className: " font-bold fss-1 ",
            render: (data, type, row, full, meta) => {
              return `
              <i class="me-3 fa fa-pencil icon-pencil" data-id="${row.valanId}" style="cursor: pointer"></i>
            `;
            },
          }, 
    ]

    const handleSaveChanges = () => {
            const selectedData = {
                adminId: user.adminId,
                segment: selectedItem.segment,
                symbol: selectedItem.symbol,
                quantity: selectedItem.quantity
            };
               
            const updatedList = valanList.map(item => {
                if (item.symbol === selectedData.symbol && item.segment === selectedData.segment) {
                    return { ...item, quantity: selectedData.quantity }; 
                }
                return item;
            });
    
            setValanList(updatedList);      
            
            RateOfPointService.updateRateOfPoint(selectedData)
                .then(res => {
                    if (res.code === 1) {
                        Swal.fire({
                            icon: "success",
                            text: "Updated Successfully!!.."
                        });
                        setShowModal(false); 
                    }
                })
                .catch(error => {              
                    alert('Error updating data.'); 
                });
        };

    return (
        <div>
            <Card className='mt-1'>
                <Card.Body>
                    <Row>
                        
                        <Col sm={4} xl={3} className='mt-1'>

                            <Button variant="success" size="sm " className='mt-1' onClick={handleAdd}>
                                Add Valan
                            </Button>
                        </Col>
                    </Row>

                </Card.Body>
            </Card>

            <Card className="mt-1">
                <Card.Body>
                    <div className="table-responsive">
                        {loading ? (
                            <div className="container vh-100">
                                <div className="d-flex align-items-center justify-content-center h-90">
                                    <div className="spinner-border text-secondary m-5" role="status" style={{ width: '4rem', height: '4rem' }}>
                                        <span className="visually-hidden">Loading...</span>
                                    </div>
                                </div>
                            </div>
                        ) : (
                            <DataTable
                                id="table"
                                className="table table-bordered bg-head-secondary fss-09 white-bordered-table"
                                columns={columns} 
                                data={valanList}
                                keyField="symbol"
                                defaultSortFieldId={1}  // Sort by START DATE (index starts from 1)
                                defaultSortAsc={false}  // Descending order
                            />
                        )}
                    </div>
                </Card.Body>
            </Card>


            <Modal show={showModal} onHide={handleClose}>
                <Modal.Header closeButton>
                    <Modal.Title>Edit RateOfPoint</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    {selectedItem && (
                        <Form>
                            <Form.Group controlId="formMarket">
                            <Row>
                                <Col sm="2">
                                    <Form.Label>Market:</Form.Label></Col>
                                <Col sm="2">
                                    <Form.Label className='fss-09'>{selectedItem.segment}</Form.Label>
                                </Col>
                                <Col sm="2">
                                    <Form.Label>Script:</Form.Label></Col>
                                <Col sm="2">
                                    <Form.Label className='fss-09'>{selectedItem.symbol}</Form.Label>
                                </Col>
                            </Row> 
                            </Form.Group>

                            <Form.Group controlId="formQuantity" className="align-items-center">
                                <Row>
                                    <Col sm="2" className='pt-2'>
                                        <Form.Label >Quantity:</Form.Label></Col>
                                    <Col sm="5">
                                        <Form.Control
                                            type="number"
                                            value={selectedItem.quantity}
                                            onChange={(e) => {
                                                setSelectedItem({ ...selectedItem, quantity: e.target.value });
                                            }}
                                        />
                                    </Col>
                                </Row>
                            </Form.Group>
                        </Form>
                    )}
                </Modal.Body>

                <Modal.Footer>
                    <Button variant="danger" onClick={handleClose}>
                        Close
                    </Button>
                    <Button variant="success" onClick={handleSaveChanges}>
                        Update
                    </Button>
                </Modal.Footer>
            </Modal>

        </div>
    );
}
export default Valan;